Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorMessage = void 0;
var _Message = require("../../components/Message");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var useErrorMessage = exports.useErrorMessage = function useErrorMessage() {
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var showErrorMessage = function showErrorMessage(text) {
    (0, _Message.ShowMessage)({
      text: text || t('useErrorMessage:message'),
      type: _Message.MessageType.alert,
      isCloseable: true
    });
  };
  return {
    showErrorMessage: showErrorMessage
  };
};